import { useTranslation } from 'next-i18next';
import { useUserContext } from 'contexts/user';
import { createLocalizedSearchPlaceholder } from 'utils/search-placeholders';
import { Namespaces } from 'types/locales';
import { SearchOptions } from '@tenants/types/theme';
import { useIsMobile } from './use-size-class';

/**
 * Hook to get internationalized search placeholders.
 * This replaces the legacy placeholder functions in tenant configurations.
 */
export function useSearchPlaceholder() {
  const { t } = useTranslation(Namespaces.SEARCH);
  const { siteLocation } = useUserContext();
  const isMobile = useIsMobile();

  /**
   * Get an internationalized placeholder for a search option
   * @param searchOption - The search option type (Buy, Rent, Sold, Agents, HomeAppraisal)
   * @param isOnMobile - Whether to show mobile-optimized (shorter) placeholder
   * @returns Internationalized placeholder string
   */
  const getPlaceholder = (searchOption: SearchOptions): string => {
    return createLocalizedSearchPlaceholder({
      t,
      searchOption,
      siteLocation,
      isMobile,
    });
  };

  return { getPlaceholder };
}
